export const DEFAULT_SPEED_KMPH = 30;
export var HorizontalAlignmentType;
(function (HorizontalAlignmentType) {
    HorizontalAlignmentType["QUADRATIC_BEZIER"] = "quadratic-bezier";
    HorizontalAlignmentType["TANGENT"] = "tangent";
    HorizontalAlignmentType["SIMPLE_CIRCULAR"] = "simple-circular";
    HorizontalAlignmentType["SPIRAL_TRANSITIONED"] = "spiral-transitioned";
})(HorizontalAlignmentType || (HorizontalAlignmentType = {}));
export var CurveDataType;
(function (CurveDataType) {
    CurveDataType["LINEAR"] = "linear";
    CurveDataType["THREE_POINT_ARC"] = "three-point-arc";
    CurveDataType["QUADRATIC_BEZIER"] = "quadratic-bezier";
    CurveDataType["CLOTHOID"] = "clothoid";
    CurveDataType["CIRCULAR_SEGMENT"] = "circular-segment";
})(CurveDataType || (CurveDataType = {}));
//# sourceMappingURL=interface.js.map